// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { TicketDescriptionEvent, TicketMessageEvent } from ".";
import styled from "@emotion/styled";
import * as React from "react";

import { getTicketMessageComponentsFromEvent } from "helpers/ticket-messages";
import { messageIsEventDescription } from "helpers/tickets";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { EventType, IEvent, ITicket } from "interfaces/entities/ticket";
import { IAgent } from "store/entities/agents";
import { ILicenseSettings } from "store/entities/license";
import { IRule } from "store/entities/rules/interfaces";
import { ITag } from "store/entities/tags";
import { ITeam } from "store/entities/teams";
import { TicketMessage } from "store/views/tickets/interfaces";

import { Attachment } from "./message-box/legacy/TicketAttachments";

interface IProps extends IWithBreakpointsProps {
  ticket: ITicket;
  agents: IAgent[];
  rules: IRule[];
  teams: ITeam[];
  tags: ITag[];
  currentAgent: IAgent;
  attachments: Attachment[];
  licenseSettings: Pick<ILicenseSettings, "showAgentTagChangeEvents">;
}

const Wrapper = styled.div`
  width: 100%;
  overflow: auto;
  scrollbar-gutter: stable both-edges;
`;

const MaxWidthWrapper = styled.div`
  margin: 0 auto;
  max-width: 900px;
`;

class TicketItem extends React.PureComponent<IProps> {
  private messagesEndRef = React.createRef<HTMLDivElement>();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    setTimeout(() => this.scrollToBottom());
  }

  componentDidUpdate(prevProps: IProps): void {
    const { events } = this.props.ticket;
    const { events: prevEvents } = prevProps.ticket;
    const eventTypes = events.map(event => event.type);
    const prevEventTypes = prevEvents.map(event => event.type);
    const shouldScrollToBottom =
      prevEventTypes.length !== eventTypes.length &&
      eventTypes
        .slice(prevEventTypes.length - eventTypes.length)
        .some(type =>
          [EventType.Message, EventType.Summary, EventType.RatingRequestSent, EventType.FollowUpSent].includes(type)
        );
    if (shouldScrollToBottom) {
      this.scrollToBottom();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private scrollToBottom = () => {
    if (this.messagesEndRef.current) {
      this.messagesEndRef.current.scrollIntoView();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { ticket, agents, teams, rules, tags, isMobile, currentAgent, licenseSettings } = this.props;

    return (
      <Wrapper>
        <MaxWidthWrapper className="fs-mask">
          {ticket.events.map((event: IEvent, i: number) => {
            if (!event.type) {
              return null;
            }

            const messages = getTicketMessageComponentsFromEvent(
              event,
              ticket.requester,
              agents,
              teams,
              rules,
              tags,
              currentAgent,
              licenseSettings
            );

            return messages.map((message: TicketMessage, j: number) => {
              if (!message) {
                return null;
              }

              if (messages)
                if (messageIsEventDescription(message)) {
                  return (
                    <TicketDescriptionEvent
                      /* eslint-disable-next-line react/no-array-index-key */
                      key={`${i}_${j}`}
                      /* we use index as a key because events do not have stable ids and are sorted by API */
                      testId={`ticket-event-${i}`}
                      isMobile={isMobile}
                      date={event.date}
                      descriptionHtml={message as string}
                      event={event}
                    />
                  );
                }

              return (
                <TicketMessageEvent
                  testId={`ticket-event-${i}`}
                  key={event.id}
                  id={event.id}
                  author={event.author ?? null}
                  agents={agents}
                  type={event.type}
                  isPrivate={Boolean(event.isPrivate)}
                  date={event.date}
                  source={event.source}
                  attachments={event.attachments ?? null}
                  stripped={event.stripped}
                  message={message as React.ReactElement}
                  isMobile={isMobile}
                  deliveryStatuses={event.deliveryStatus}
                  ticketId={ticket.id}
                  replySuggestionIDs={event.replySuggestionIDs}
                />
              );
            });
          })}
        </MaxWidthWrapper>
        <div ref={this.messagesEndRef} />
      </Wrapper>
    );
  }
}

export default withBreakpoints(TicketItem);
